import styled from 'styled-components';
import { Container } from 'styles';

export const DataAndLabelHorizontalList = styled(Container)`
  display: flex;

  div {
    flex-grow: 1;
    p {
      margin-right: 8px;
    }
  }

  div:last-child {
    p {
      margin-right: 0;
    }
  }
`;
